import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const faqService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/faq/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/faq/' + id)
    return response.data
  },
  countPinned: async () => {
    const response = await axiosInstance.get('/faq/count-pinned')
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.postForm('/faq', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.putForm(`/faq/${id}`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/faq/${id}`)
    return response.data
  },
}